<template>
  <div class="the-toaster">
    <TransitionGroup mode="out-in" name="slide-in" tag="ul">
      <li v-for="toast in toasts.slice(0, 5)" :key="toast.id">
        <ToasterToast v-bind="{ ...$attrs, ...toast }" />
      </li>
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>
import type { Toast } from '~/composables/toasterIsolated'

type ToasterProps = { toasts?: Toast[] }

const { toasts = [] } = defineProps<ToasterProps>()
</script>

<style lang="scss" scoped>
.the-toaster {
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 1900;
  width: 100vw;
  max-width: $main-content-width;
  padding: token('size/space/gap/100');
  transform: translateX(-50%);

  li {
    position: relative;

    + li {
      margin-top: token('size/space/gap/100');
    }
  }

  .slide-in {
    &-move,
    &-enter-active,
    &-leave-active {
      @include transition-default(opacity, transform);

      z-index: -1;
    }

    &-enter-from,
    &-leave-to {
      opacity: 0;
      transform: translateY(-5rem);
    }
  }
}
</style>
